export default "__VITE_ASSET__Dcu_UYCn__"